import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY } from '@/swagger/constants/surveys-keys';
import {
  API_POST_SURVEYS_CAMPAIGNS_ID_REMINDER,
  KEY_POST_SURVEYS_CAMPAIGN_BY_ID_REMINDER,
} from '../constats';
import { MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_REMINDER } from '../mocks';

type RequestPostSurveysCampaignByIdReminder = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY
>['request']['path'];

type ResponsePostSurveysCampaignByIdReminder = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY
>['response']['body'];

type CallParamsPostSurveysCampaignByIdReminder = Omit<
  RequestPostSurveysCampaignByIdReminder,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostSurveysCampaignByIdReminder = ResponsePostSurveysCampaignByIdReminder;

type CallErrorPostSurveysCampaignByIdReminder = GenericApiError;

type CallSelectorsPostSurveysCampaignByIdReminder = unknown;

export const postSurveysCampaignByIdReminderCall = createGeneralCall<
  CallParamsPostSurveysCampaignByIdReminder,
  CallResponsePostSurveysCampaignByIdReminder,
  CallErrorPostSurveysCampaignByIdReminder,
  CallSelectorsPostSurveysCampaignByIdReminder
>({
  id: KEY_POST_SURVEYS_CAMPAIGN_BY_ID_REMINDER,
  method: 'post',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_SURVEYS_CAMPAIGNS_ID_REMINDER(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_REMINDER
    : undefined,
});
